import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="border-t px-4 py-4 shadow-inner bg-background fixed bottom-1 left-0 w-full">
    <div className="flex justify-center items-center max-w-[1100px] w-full mx-auto">
      <a
        href="https://www.levialabs.net"
        target="_blank"
        rel="noopener noreferrer"
        className="text-sm text-muted-foreground hover:underline"
      >
        Levia Labs © {new Date().getFullYear()}
      </a>
    </div>
  </footer>
);
